import { sdkRequest } from 'js-utils/http';

// See here all the possible email names
// https://github.com/eventbrite/core/blob/master/django/src/www/eventbrite/ebapps/email/__init__.py#L281
const LIKED_EVENT_REMINDERS_EMAIL = 'liked_event_reminders_email';
const NOTIFY_ORGANIZER_FOLLOWER_ON_PUBLISH_EMAIL =
    'notify_organizer_follower_on_publish_email';
const COLLECTION_FOLLOW_EMAIL = 'collection_follow_email';
const REMIND_ME_EMAIL = 'remind_me_email';
const emailToEmailName = {
    remind_me: REMIND_ME_EMAIL,
    liked_event: LIKED_EVENT_REMINDERS_EMAIL,
    organizer_follow: NOTIFY_ORGANIZER_FOLLOWER_ON_PUBLISH_EMAIL,
    collection_follow: COLLECTION_FOLLOW_EMAIL,
};

const emailPreferencesRootURL = (userId) =>
    `/api/v3/user/${userId}/email_preferences/`;
const emailPreferenceGetURL = (email, userId) =>
    `${emailPreferencesRootURL(userId)}?email_names=${emailToEmailName[email]}`;

// Follow Organizer Email
export const getFollowOrganizerStatus = (userId) =>
    sdkRequest(emailPreferenceGetURL('organizer_follow', userId));
export const setFollowOrganizerStatus = (userId, newState) =>
    sdkRequest(emailPreferencesRootURL(userId), {
        method: 'POST',
        body: JSON.stringify({
            email_name: emailToEmailName['organizer_follow'],
            can_send: !!newState,
        }),
    });

// Follow Collection Email
export const getFollowCollectionStatus = (userId) =>
    sdkRequest(emailPreferenceGetURL('collection_follow', userId));
export const setFollowCollectionStatus = (userId, newState) =>
    sdkRequest(emailPreferencesRootURL(userId), {
        method: 'POST',
        body: JSON.stringify({
            email_name: emailToEmailName['collection_follow'],
            can_send: !!newState,
        }),
    });

// Liked Events Reminder Email
export const getLikedEventStatus = (userId) =>
    sdkRequest(emailPreferenceGetURL('liked_event', userId));
export const setLikedEventStatus = (userId, newState) =>
    sdkRequest(emailPreferencesRootURL(userId), {
        method: 'POST',
        body: JSON.stringify({
            email_name: emailToEmailName['liked_event'],
            can_send: !!newState,
        }),
    });

// Remind Me Email
export const getRemindMeStatus = (userId) =>
    sdkRequest(emailPreferenceGetURL('remind_me', userId));
export const setRemindMeStatus = (userId, newState) =>
    sdkRequest(emailPreferencesRootURL(userId), {
        method: 'POST',
        body: JSON.stringify({
            email_name: emailToEmailName['remind_me'],
            can_send: !!newState,
        }),
    });
